import { FormatListBulleted, LocalHospital } from "@mui/icons-material";
import { Unstable_Grid2 as Grid, IconButton } from "@mui/material";
import { useStore } from "../../store/store";

export const ToggleBetweenTreatmentsDisplay = () => {
    const { treatments } = useStore();

    return (
        <Grid container spacing={2} alignItems="center" display="flex" flexDirection="row">
            <Grid>
                <IconButton onClick={() => treatments.setView("list")}>
                    <FormatListBulleted />
                </IconButton>
                <IconButton onClick={() => treatments.setView("scheduleWarnings")}>
                    <LocalHospital />
                </IconButton>
            </Grid>
        </Grid>
    );
};